import React, { useEffect, useState } from "react";
import { handleSpringDataRequest } from "../../../../api";
import { format } from "date-fns";
import { DATE_FORMATS } from "../../../../Utils/CONST";
import { roundIfDecimal } from "../../../../Utils/Utils";

const useGroupPerformanceData = (properties, date, groupId, emailId) => {
  const [groupPerformanceData, setGroupPerformanceData] = useState(null);
  const [groupPerformanceLoading, setGroupPerformanceLoading] = useState(false);

  useEffect(() => {
    if (!properties || properties.length === 0) return;
    if (!groupId || groupId === "null" || groupId === "undefined") return;
    if (!emailId || emailId === "null" || emailId === "undefined") return;
    // const combinedHotelIds = properties.reduce(
    //   (accumulator, val) => accumulator + "&hotelIds=" + val,
    //   ""
    // );
    const combinedHotelIds = "&hotelIds=" + properties.join(",");
    const forDate = date ? date : format(new Date(), DATE_FORMATS.DATE_2);
    const queryString = `date=${forDate}&groupId=${encodeURIComponent(
      groupId
    )}&emailId=${encodeURIComponent(emailId)}${combinedHotelIds}`;
    setGroupPerformanceLoading(true);
    handleSpringDataRequest(
      `core/api/v1/reports/get-group-performance-dashboard?${queryString}`
    )
      .then((res) => {
        const roundedOffData = (() => {
          res.groupDayWisePerformanceBreakdown.forEach((element) => {
            element.adr = roundIfDecimal(element.adr, 2);
            element.availableRooms = roundIfDecimal(element.availableRooms, 2);
            element.blockedRooms = roundIfDecimal(element.blockedRooms, 0);

            element.occupancy = roundIfDecimal(element.occupancy, 0);
            element.revPAR = roundIfDecimal(element.revPAR);
            element.revenue = roundIfDecimal(element.revenue, 2);
            element.roomsSold = roundIfDecimal(element.roomsSold, 0);
            element.unassignedRooms = roundIfDecimal(
              element.unassignedRooms,
              0
            );
          });

          const groupMetricMtd = res.groupMetricsBreakDown.groupMetricsMtd;
          res.groupMetricsBreakDown.groupMetricsMtd = {
            adr: roundIfDecimal(groupMetricMtd.adr, 2),
            occupancy: roundIfDecimal(groupMetricMtd.occupancy, 0),
            revPar: roundIfDecimal(groupMetricMtd.revPar, 2),
            totalAvailableRooms: roundIfDecimal(
              groupMetricMtd.totalAvailableRooms,
              0
            ),
            totalRevenue: roundIfDecimal(groupMetricMtd.totalRevenue, 2),
            totalroomsSold: roundIfDecimal(groupMetricMtd.totalroomsSold, 0),
          };

          const groupMetricTd = res.groupMetricsBreakDown.groupMetricsTd;
          res.groupMetricsBreakDown.groupMetricstd = {
            adr: roundIfDecimal(groupMetricTd.adr, 2),
            occupancy: roundIfDecimal(groupMetricTd.occupancy, 0),
            revPar: roundIfDecimal(groupMetricTd.revPar, 2),
            totalAvailableRooms: roundIfDecimal(
              groupMetricTd.totalAvailableRooms,
              0
            ),
            totalRevenue: roundIfDecimal(groupMetricTd.totalRevenue, 2),
            totalroomsSold: roundIfDecimal(groupMetricTd.totalroomsSold, 0),
          };

          res.groupSourceWiseMetricsBreakdown.mtdGroupSourceWiseMetrics.forEach(
            (item) => {
              item.revenue = roundIfDecimal(item.revenue, 2);
              item.roomsSold = roundIfDecimal(item.roomsSold, 0);
            }
          );
          res.groupSourceWiseMetricsBreakdown.tdGroupSourceWiseMetrics.forEach(
            (item) => {
              item.revenue = roundIfDecimal(item.revenue, 2);
              item.roomsSold = roundIfDecimal(item.roomsSold, 0);
            }
          );
          (
            res.groupSourceWiseMetricsBreakdown.ytdGroupSourceWiseMetrics || []
          ).forEach((item) => {
            item.revenue = roundIfDecimal(item.revenue, 2);
            item.roomsSold = roundIfDecimal(item.roomsSold, 0);
          });

          res.hotelWiseMetricsBreakdown.mtd.forEach((item) => {
            item.adr = roundIfDecimal(item.adr, 2);
            item.availableRooms = roundIfDecimal(item.availableRooms, 0);
            item.blockedRooms = roundIfDecimal(item.blockedRooms, 0);
            item.occupancy = roundIfDecimal(item.occupancy, 0);
            item.revPar = roundIfDecimal(item.revPar, 2);
            item.revenue = roundIfDecimal(item.revenue, 2);
            item.roomsSold = roundIfDecimal(item.roomsSold, 0);
            item.unassignedRooms = roundIfDecimal(item.unassignedRooms, 0);
          });
          res.hotelWiseMetricsBreakdown.td.forEach((item) => {
            item.adr = roundIfDecimal(item.adr, 2);
            item.availableRooms = roundIfDecimal(item.availableRooms, 0);
            item.blockedRooms = roundIfDecimal(item.blockedRooms, 0);
            item.occupancy = roundIfDecimal(item.occupancy, 0);
            item.revPar = roundIfDecimal(item.revPar, 2);
            item.revenue = roundIfDecimal(item.revenue, 2);
            item.roomsSold = roundIfDecimal(item.roomsSold, 0);
            item.unassignedRooms = roundIfDecimal(item.unassignedRooms, 0);
          });
          (res.hotelWiseMetricsBreakdown.ytd || []).forEach((item) => {
            item.adr = roundIfDecimal(item.adr, 2);
            item.availableRooms = roundIfDecimal(item.availableRooms, 0);
            item.blockedRooms = roundIfDecimal(item.blockedRooms, 0);
            item.occupancy = roundIfDecimal(item.occupancy, 0);
            item.revPar = roundIfDecimal(item.revPar, 2);
            item.revenue = roundIfDecimal(item.revenue, 2);
            item.roomsSold = roundIfDecimal(item.roomsSold, 0);
            item.unassignedRooms = roundIfDecimal(item.unassignedRooms, 0);
          });
          return res;
        })();

        setGroupPerformanceData(roundedOffData);
      })
      .catch((e) => {
        console.error("error occured", e);
      })
      .finally(() => {
        setGroupPerformanceLoading(false);
      });
  }, [properties, date, groupId, emailId]);

  return { data: groupPerformanceData, loading: groupPerformanceLoading };
};

export default useGroupPerformanceData;
